import GuideSDK from '@/docs-partials/sdk/guide.mdx';
import * as React from 'react';
export default {
  GuideSDK,
  React
};